export default function StageMessage({ stage, onRetry }) {
  const configs = {
    2: {
      icon: '🔒',
      title: 'Nominations Are Closed',
      body: 'Voting is now open. Stay tuned for the results.',
    },
    3: {
      icon: '🏆',
      title: 'Thank You!',
      body: 'This awards event has concluded. Thank you for participating.',
    },
    error: {
      icon: '⚠️',
      title: 'Portal Unavailable',
      body: 'This nominations portal is currently unavailable. Please try again later.',
    },
    unauthorized: {
      icon: '🚫',
      title: 'Not Configured',
      body: 'This portal is not configured correctly. Please contact the organiser.',
    },
  };

  const { icon, title, body } = configs[stage] || configs.error;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center px-4 py-5 mt-5">
      <div className="stage-icon mb-3">{icon}</div>
      <h2 className="fw-bold text-dark mb-2">{title}</h2>
      <p className="text-muted mb-4">{body}</p>
      {stage === 'error' && onRetry && (
        <button onClick={onRetry} className="btn btn-outline-secondary px-4">
          Try Again
        </button>
      )}
    </div>
  );
}
